import { configureStore } from "@reduxjs/toolkit";
import planesReducer from "./planeSlice";
import simReducer from "./simSlice";
import userReducer from "./userSlice";

const store = configureStore({
    reducer: {
        planes: planesReducer,
        sim: simReducer,
        user: userReducer
    }
});

export default store;